@if (quickCoverageDocs) {
  <div class="tabbody" style="display: block;">
    <div class="row">
      <div class="col-sm-12 col-md-12 col-lg-12 p-3">
        <div class="tab-container quickCoverGuide-tab col-12 row">
          @for (doc of quickCoverageDocs; track doc) {
            <div class="col-xs-12 col-sm-6">
              <div class="pdp-tabdocument-inside downloadTab quickCover-downloadTab">
                <a class="pdtext quickCover-Guide-link" [href]='doc.url' target="_blank"
                rel="noopener noreferrer">{{doc.code}}&nbsp;{{doc?.description}}</a>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
}